module.exports = __webpack_public_path__ + "media/images/countryrect/ky-10303fb70a36a14289dab7e29a54806e.svg";